/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from 'helpers/store'
import { openSecondaryModal, closeSecondaryModal } from 'helpers/actions'
import { ModalSize } from 'types/enums/ModalSize'
import { Lead } from 'types/entities/Lead'
import LeadsAction from 'store/leads/LeadsAction'
import EditLeadModal from 'components/leads/EditLeadModal'
import EditCompanyModalLeadsTab from './EditCompanyModalLeadsTab'
import { toast } from 'utils/toastUtils'

interface EditCompanyModalOpportunitiesTabProps {
    opportunities: Lead[]
    onSuccess: () => void
}

const EditCompanyModalOpportunitiesTab: React.FC<EditCompanyModalOpportunitiesTabProps> = ({
    opportunities,
    onSuccess,
}) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    const handleOpportunityClick = (lead: Lead) => {
        dispatch(LeadsAction.fetchLeadById(lead))
            .then((loadedLead: Lead) =>
                dispatch(
                    openSecondaryModal(
                        <EditLeadModal
                            lead={loadedLead}
                            onSuccess={onSuccess}
                            isSecondary={true}
                        />,
                        {
                            modalSize: ModalSize.RoundedFullscreen,
                            closeModal: () => dispatch(closeSecondaryModal()),
                        },
                        t('Edit Opportunity')
                    )
                )
            )
            .catch(() => toast.error(t('Failed to load lead information')))
    }

    return (
        <EditCompanyModalLeadsTab
            leads={opportunities}
            title={t('Opportunities')}
            onLeadClick={handleOpportunityClick}
        />
    )
}

export default EditCompanyModalOpportunitiesTab
